import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { useAuth } from '../contexts/AuthContext';

// Admin Pages
import AdminDashboard from '../pages/admin/Dashboard';
import AgenciesList from '../pages/admin/Agencies';
import AreasList from '../pages/admin/Areas';
import Countries from '../pages/Countries';
import PacksList from '../pages/admin/Packs';
import UpdatePacksPrices from '../pages/admin/UpdatePacksPrices';
import ImportPacksPrices from '../pages/admin/ImportPacksPrices';
import AdminSubscribersList from '../pages/admin/Subscribers';
import AdminTransactionsList from '../pages/admin/Transactions';
import AdminVouchersList from '../pages/admin/Vouchers';
import StripeIntegrationDemo from '../pages/StripeIntegrationDemo';
import ManualPaymentsAdmin from '../pages/admin/ManualPayments';
import ImportEsimInventory from '../pages/admin/ImportEsimInventory';

// Agency Pages
import AgencyDashboard from '../pages/agency/Dashboard';
import AgencyVouchers from '../pages/agency/Vouchers';
import AgencyPacks from '../pages/agency/Packs';
import AgencyCart from '../pages/agency/Cart';
import ManualPayment from '../pages/agency/ManualPayment';
import InvoiceHistory from '../pages/agency/InvoiceHistory';

// Common Pages
import Profile from '../pages/Profile';
import Login from '../pages/SignIn';
import SignUp from '../pages/SignUp';
import NotFound from '../pages/NotFound';
import Unauthorized from '../pages/Unauthorized';
import PdfViewerPage from '../pages/PdfViewerPage';
import AgencyTransactions from 'pages/agency/Transactions';
import DemandPayment from 'pages/agency/DemandPayment';

const Routes = () => {
  const { isAuthenticated, user, checkTokenValidity } = useAuth();
  
  // Vérifier la validité du token lors du chargement des routes
  React.useEffect(() => {
    if (isAuthenticated) {
      checkTokenValidity();
    }
  }, [isAuthenticated, checkTokenValidity]);

  return (
    <Switch>
      <Route exact path="/login" render={(props) => {
        // Rediriger vers le tableau de bord approprié si déjà connecté
        if (isAuthenticated && user && user.authorities) {
          if (user.authorities.includes('ROLE_ADMIN')) {
            return <Redirect to="/admin/dashboard" />;
          } else if (user.authorities.includes('ROLE_AGENCY')) {
            return <Redirect to="/agency/dashboard" />;
          } else if (user.authorities.includes('ROLE_SUBSCRIBER')) {
            return <Redirect to="/subscriber/dashboard" />;
          }
        }
        // Sinon, afficher la page de connexion
        return <Login {...props} />;
      }} />
      
      {/* Admin Routes */}
      <ProtectedRoute
        path="/admin/dashboard"
        roles={['ROLE_ADMIN']}
        component={AdminDashboard}
      />
      <ProtectedRoute
        path="/admin/agencies"
        roles={['ROLE_ADMIN']}
        component={AgenciesList}
      />
      <ProtectedRoute
        path="/admin/areas"
        roles={['ROLE_ADMIN']}
        component={AreasList}
      />
      <ProtectedRoute
        path="/admin/countries"
        roles={['ROLE_ADMIN']}
        component={Countries}
      />
      <ProtectedRoute
        path="/admin/packs"
        roles={['ROLE_ADMIN']}
        component={PacksList}
      />
      <ProtectedRoute
        path="/admin/update-packs-prices"
        roles={['ROLE_ADMIN']}
        component={UpdatePacksPrices}
      />
      <ProtectedRoute
        path="/admin/import-packs-prices"
        roles={['ROLE_ADMIN']}
        component={ImportPacksPrices}
      />
      <ProtectedRoute
        path="/admin/subscribers"
        roles={['ROLE_ADMIN']}
        component={AdminSubscribersList}
      />
      <ProtectedRoute
        path="/admin/transactions"
        roles={['ROLE_ADMIN']}
        component={AdminTransactionsList}
      />
      <ProtectedRoute
        path="/admin/vouchers"
        roles={['ROLE_ADMIN']}
        component={AdminVouchersList}
      />
      <ProtectedRoute
        path="/admin/stripe-demo"
        roles={['ROLE_ADMIN']}
        component={StripeIntegrationDemo}
      />
      <ProtectedRoute
        path="/admin/manual-payments"
        roles={['ROLE_ADMIN']}
        component={ManualPaymentsAdmin}
      />
      <ProtectedRoute
        path="/admin/import-esim-inventory"
        roles={['ROLE_ADMIN']}
        component={ImportEsimInventory}
      />

      {/* Agency Routes */}
      <ProtectedRoute
        path="/agency/dashboard"
        roles={['ROLE_AGENCY']}
        component={AgencyDashboard}
      />
      <ProtectedRoute
        path="/agency/vouchers"
        roles={['ROLE_AGENCY']}
        component={AgencyVouchers}
      />
      <ProtectedRoute
        path="/agency/packs"
        roles={['ROLE_AGENCY']}
        component={AgencyPacks}
      />
      <ProtectedRoute
        path="/agency/cart"
        roles={['ROLE_AGENCY']}
        component={AgencyCart}
      />
      <ProtectedRoute
        path="/agency/orders"
        roles={['ROLE_AGENCY']}
        component={AgencyTransactions}
      />
      <ProtectedRoute
        path="/agency/manual-payment"
        roles={['ROLE_AGENCY']}
        component={ManualPayment}
      />

       <ProtectedRoute
        path="/agency/demand-payment"
        roles={['ROLE_AGENCY']}
        component={DemandPayment}
      />


      <ProtectedRoute
        path="/agency/invoice-history"
        roles={['ROLE_AGENCY']}
        component={InvoiceHistory}
      />

      {/* Common Routes */}
      <ProtectedRoute
        path="/profile"
        roles={['ROLE_ADMIN', 'ROLE_AGENCY']}
        component={Profile}
      />
        <Route path="/sign-up" component={SignUp} />
      <Route
        exact
        path="/terms"
        render={() => (
          <PdfViewerPage pdfPath="/terms.pdf" titleKey="footer.termsOfService" />
        )}
      />
      <Route
        exact
        path="/privacy"
        render={() => (
          <PdfViewerPage pdfPath="/privacy.pdf" titleKey="footer.privacyPolicy" />
        )}
      />
      <Route path="/404" component={NotFound} />
      <Route path="/unauthorized" component={Unauthorized} />
      <Redirect from="/" exact to="/login" />
      <Redirect to="/404" />
    </Switch>
  );
};

export default Routes;
